const firebaseConfig = {
    apiKey: "AIzaSyD39s7pHSKmOfu0xdreosTiVjSKrG51IY0",
    authDomain: "ki-lagbe-1.firebaseapp.com",
    projectId: "ki-lagbe-1",
    storageBucket: "ki-lagbe-1.appspot.com",
    messagingSenderId: "966428926760",
    appId: "1:966428926760:web:87c55c9fffbceaca13261d"
  };
export default firebaseConfig;